import { render, staticRenderFns } from "./ScheduledCallsAutoStatus.container.vue?vue&type=template&id=36b97724&scoped=true&"
import script from "./ScheduledCallsAutoStatus.container.vue?vue&type=script&lang=js&"
export * from "./ScheduledCallsAutoStatus.container.vue?vue&type=script&lang=js&"
import style0 from "./ScheduledCallsAutoStatus.container.vue?vue&type=style&index=0&id=36b97724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b97724",
  null
  
)

export default component.exports